export class UpdateOrderPartMessage {
  action?: number
  price: number
  purchaseOrderItemId?: number

  constructor(action: number|undefined, price: number, purchaseOrderItemId: number|undefined) {
    this.action = action
    this.price = price
    this.purchaseOrderItemId = purchaseOrderItemId
  }
}
    